import { Icon, type IconProps } from "@chakra-ui/react";

const CircleHelpIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.06016 6.4987C6.2169 6.05314 6.52626 5.67744 6.93347 5.43812C7.34067 5.1988 7.81943 5.11132 8.28495 5.19117C8.75047 5.27102 9.17271 5.51305 9.47688 5.87438C9.78106 6.23572 9.94753 6.69305 9.94683 7.16536C9.94683 8.4987 7.94683 9.16536 7.94683 9.16536M8.00016 11.832H8.00683M14.6668 8.4987C14.6668 12.1806 11.6821 15.1654 8.00016 15.1654C4.31826 15.1654 1.3335 12.1806 1.3335 8.4987C1.3335 4.8168 4.31826 1.83203 8.00016 1.83203C11.6821 1.83203 14.6668 4.8168 14.6668 8.4987Z"
				stroke="currentColor"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};

export default CircleHelpIcon;
